<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <help-link appId="settings" pageId="access-control" color="white"></help-link>
                    <v-spacer></v-spacer>  
                    <v-btn v-if="!loading&&hasEditRights" dark icon title="Copy from template" @click="copyFromTemplate">
                        <v-icon>file_open</v-icon>
                    </v-btn>
                    <v-btn v-if="!loading&&hasEditRights&&(forReview||approved||underRevision)" dark icon title="Save as template" @click="saveAsTemplate">
                        <v-icon>file_copy</v-icon>
                    </v-btn>
                    <v-menu left v-if="!loading&&(hasEditRights||hasApproverRights)" v-model="menu_status" offset-y :disabled="notUpdated||approved||(forReview&&!hasApproverRights)">
                         <template v-slot:activator="{ on }">
                             <v-btn v-show="notUpdated" v-on="on" :loading="loading_status" class="mr-0">
                                <span class="ml-7">Not Updated</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="underRevision" v-on="on" color="orange" dark :loading="loading_status"  class="mr-0">
                                <span class="ml-7">Under Revision</span> 
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="forReview" v-on="on" color="orange" dark :loading="loading_status"  class="mr-0">
                                <span class="ml-7">For Review</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="approved" v-on="on" color="green" dark :loading="loading_status"  class="mr-0">
                                <span class="ml-7">Approved</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-show="hasRevised&&hasEditRights" :key="0" @click="setForReview" title="Set all revised to For Review">
                                <v-list-tile-title small>Set For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasForReview&&hasApproverRights" :key="1" @click="setToApproved" title="Approve all For Review">
                                <v-list-tile-title small>Approve For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasForReview&&hasApproverRights" :key="2" @click="setToRejected" title="Reject all For Review">
                                <v-list-tile-title small>Reject For Review</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>  
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="top-progress"></v-progress-linear>
            </v-card>
            
            <v-alert v-if="hasRevised" :value="true" color="info" icon="info" outline dismissible class="mt-8">
                Changes to Access Control will take effect after next login of the user.
            </v-alert>  

            <v-expansion-panel v-model="panel" expand class="mt-5">
                <!-- Employee Details -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold  primary--text">EMPLOYEE</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Employee :
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            <v-chip @click="viewUserProfile(user_detail, $store.state.userId)" class="user-chip-container">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(user_detail.userId)"></v-img>
                                                </v-avatar>
                                                {{user_detail.firstName}} {{user_detail.lastName}}
                                            </v-chip>
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Employee Id : 
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{user_detail.employeeId}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Position : 
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            <span v-if="user_detail.position!=null">{{user_detail.position}}</span>
                                            <span v-else class="orange--text">Not Updated</span>
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Employment Type :
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{commonfn.getStatusDescription(user_detail.employmentType)}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Employment Status : 
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{commonfn.getStatusDescription(user_detail.employmentStatus)}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Teams :
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            <team-chips :teams="user_detail.teams"></team-chips>
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- application access -->
                <v-expansion-panel-content v-for="(item,index) in apps_list" :key="index">
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-8px;':''">
                            {{ item.appName.toUpperCase() }} &nbsp;
                            <span v-if="getCountPerStatus(item.appId,commonfn.getStatusCode('Approved'))>0" class="caption green--text">Approved ({{getCountPerStatus(item.appId,commonfn.getStatusCode('Approved'))}})&nbsp;</span>
                            <span v-if="getCountPerStatus(item.appId,-1)>0" class="caption red--text">Revised ({{getCountPerStatus(item.appId,-1)}})&nbsp;</span>
                            <span v-if="getCountPerStatus(item.appId,commonfn.getStatusCode('For Review'))>0" class="caption orange--text">For Review ({{getCountPerStatus(item.appId,commonfn.getStatusCode('For Review'))}})</span>
                        </span>
                        <v-spacer></v-spacer>
                    </template>
                    <div v-if="item.appId == appIds.my_team" class="mr-20 ml-20">
                        <v-alert :value="true" color="info" icon="info" outline>
                            To manage <i>My Teams</i> page permissions, first create Team Membership Roles in <b><u @click="$router.push('/settings/teamroles')" style="cursor:pointer;" title="Click to navigate to Settings > Team Membership Role page">Settings > Team Membership Roles</u></b> page, then assign a role in <b>User Profile > Team Membership</b> page. Predefined roles are also available.
                        </v-alert>  
                    </div>
                    <div v-else>
                        <v-data-table
                            :headers="isMobile ? [] : headers"
                            :items="item.appPages"
                            :hide-headers="isMobile"
                            hide-actions
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="headers.length" class="pa-1">
                                        <v-card class="elevation-1" @click="viewDetails(props.item)">
                                            <v-toolbar flat height="42">
                                                <v-chip class="user-chip-container font-weight-bold">
                                                    {{ props.item.pageName }}
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Visible</div>
                                                            <v-switch v-if="props.item.visibleRequired" v-model="props.item.accessRights.visible" :readonly="!hasEditRights" color="primary" @change="updateVisibility(item.appId, props.item)" title="Click to change Visibility" class="switch-item"></v-switch>
                                                            <div v-else>N/A</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">View</div>
                                                            <v-switch v-model="props.item.accessRights.view" :readonly="!hasEditRights" color="primary" @change="updateView(item.appId, props.item)" title="Click to change View access" class="switch-item"></v-switch>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Add</div>
                                                            <v-switch v-if="props.item.addRequired" v-model="props.item.accessRights.add" :readonly="!hasEditRights" color="primary" @change="updateAdd(item.appId, props.item)" title="Click to change Add access" class="switch-item"></v-switch>
                                                            <div v-else>N/A</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Edit</div>
                                                            <v-switch v-if="props.item.editRequired" v-model="props.item.accessRights.edit" :readonly="!hasEditRights" color="primary" @change="updateEdit(item.appId, props.item)" title="Click to change Edit access" class="switch-item"></v-switch>
                                                            <div v-else>N/A</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Delete</div>
                                                            <v-switch v-if="props.item.deleteRequired" v-model="props.item.accessRights.delete" :readonly="!hasEditRights" color="primary" @change="updateDelete(item.appId, props.item)" title="Click to change Delete access" class="switch-item"></v-switch>
                                                            <div v-else>N/A</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Approver</div>
                                                            <v-switch v-if="props.item.approverRequired" v-model="props.item.accessRights.approver" :readonly="!hasEditRights" color="primary" @change="updateApprover(item.appId, props.item)" title="Click to change Approver rights" class="switch-item"></v-switch>
                                                            <div v-else>N/A</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs12>
                                                            <div class="caption grey--text text--darken-1">Status</div>
                                                            <div v-if="props.item.status==-1" class="red--text">Revised</div>
                                                            <div v-if="props.item.status==commonfn.getStatusCode('For Review')" class="orange--text">For Review</div>
                                                            <div v-if="props.item.status==commonfn.getStatusCode('Approved')" class="green--text">Approved</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td :title="props.item.pageDescription">
                                        <v-chip class="user-chip-container">
                                            {{ props.item.pageName }}
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-switch v-if="props.item.visibleRequired" v-model="props.item.accessRights.visible" :readonly="!hasEditRights" color="primary" @change="updateVisibility(item.appId, props.item)" title="Click to change Visibility" class="switch-item"></v-switch>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td>
                                        <v-switch v-model="props.item.accessRights.view" :readonly="!hasEditRights" color="primary" @change="updateView(item.appId, props.item)" title="Click to change View access" class="switch-item"></v-switch>
                                    </td>
                                    <td>
                                        <v-switch v-if="props.item.addRequired" v-model="props.item.accessRights.add" :readonly="!hasEditRights" color="primary" @change="updateAdd(item.appId, props.item)" title="Click to change Add access" class="switch-item"></v-switch>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td>
                                        <v-switch v-if="props.item.editRequired" v-model="props.item.accessRights.edit" :readonly="!hasEditRights" color="primary" @change="updateEdit(item.appId, props.item)" title="Click to change Edit access" class="switch-item"></v-switch>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td>
                                        <v-switch v-if="props.item.deleteRequired" v-model="props.item.accessRights.delete" :readonly="!hasEditRights" color="primary" @change="updateDelete(item.appId, props.item)" title="Click to change Delete access" class="switch-item"></v-switch>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td>
                                        <v-switch v-if="props.item.approverRequired" v-model="props.item.accessRights.approver" :readonly="!hasEditRights" color="primary" @change="updateApprover(item.appId, props.item)" title="Click to change Approver rights" class="switch-item"></v-switch>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td>
                                        <span v-if="props.item.status==-1" class="red--text">Revised</span>
                                        <span v-if="props.item.status==commonfn.getStatusCode('For Review')" class="orange--text">For Review</span>
                                        <span v-if="props.item.status==commonfn.getStatusCode('Approved')" class="green--text">Approved</span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialog_saveas" width="700" persistent>   
            <save-as-template ref="saveAsRef" :dialog_saveas.sync="dialog_saveas"></save-as-template>
        </v-dialog>
        <v-dialog v-model="dialog_copy" width="700" persistent>   
            <copy-from-template ref="copyFromRef" @send="getAllApps(false)" :dialog_copy.sync="dialog_copy"></copy-from-template>
        </v-dialog>

        <!-- status messaging component. todo - convert this to js script only -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'   //for refactor
import appsApi from '@/api/applications'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import appIds from '@/constants/app_ids'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {     
    name: 'AccessControl',
    metaInfo: {
        title: 'Access Control',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Access Control' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'save-as-template': () => import('@/components/AccessPermissions/SaveAsTemplate'),
        'team-chips': () => import("@/components/Common/TeamsChip"),
        'copy-from-template': () => import('@/components/AccessPermissions/CopyFromTemplate')
    },   
    data () {
        return {
            appIds,
            commonfn,
            awsS3Helper,
            error: false,
            errorMessage: '',
            message: null,
            loading: false,
            loading_status: false,
            dialog_saveas: false,
            dialog_copy: false,
            panel: [true],
            menu_status: false,
            apps_list: null,
            apps_list_orig: [],
            pages_modified: [],
            user_detail: null,
            headers: [
                {text: 'Page',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Visible',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'View',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Add',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Edit',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Delete',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Approver',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '5%', sortable:false},
            ],
        }
    },
    methods: {
        saveAsTemplate() {
            this.$refs.saveAsRef.loadTemplates(this.selectedUserId)
            this.dialog_saveas = true
        },
        copyFromTemplate() {
            this.$refs.copyFromRef.loadTemplates(this.selectedUserId)
            this.dialog_copy = true
        },
        async setToRejected() {
            try{
                this.loading_status = true
                if (this.forReviewList.length>0) {
                    const response = await appsApi.rejectAccessRights(this.forReviewList, this.selectedUserId)
                    if (response.status==200){
                        await this.getAllApps(false)
                    }
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setToApproved() {
            try{
                this.loading_status = true
                if (this.forReviewList.length>0) {
                    const response = await appsApi.approveAccessRights(this.forReviewList, this.selectedUserId)
                    if (response.status==200){
                        await this.getAllApps(false)
                    }
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setForReview() {
            //pass pages_modified to api
            try {
                this.loading_status = true
                const response = await appsApi.updateAccessRights(this.pages_modified, this.selectedUserId)
                if (response.status==200){
                    await this.getAllApps(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        processData(appId, data) {
            //Need to update the modified row in page to set status to Revised
            //If rolled back to original value, need to update the status to original status           
            var matchApp = this.apps_list_orig.filter(x => {
                return x.appId == appId
            })
            var origPage = matchApp[0].appPages.filter(x => {
                return x.appPageId == data.appPageId
            })[0]

            if (origPage.accessRights.visible == data.accessRights.visible &&
                origPage.accessRights.view == data.accessRights.view &&
                origPage.accessRights.add == data.accessRights.add &&
                origPage.accessRights.edit == data.accessRights.edit &&
                origPage.accessRights.delete == data.accessRights.delete &&
                origPage.accessRights.approver == data.accessRights.approver){

                //set to origin status in UI
                data.status = origPage.status

                //remove from list of for batch upate
                var indexToRemove = this.pages_modified.indexOf(data)
                this.pages_modified.splice(indexToRemove,1)
            }else{
                //set status to Revised
                data.status = -1

                // if revised, add to list of for batch update
                if (this.pages_modified.indexOf(data) == -1)
                    this.pages_modified.push(data)
            }
        },
        updateVisibility(appId, data) {
            this.processData(appId, data)
        },
        updateView(appId, data) {
            //edit and approver rights should always have view rights
            if (!data.accessRights.view) {
                data.accessRights.add = false
                data.accessRights.edit = false
                data.accessRights.delete = false
                data.accessRights.approver = false
            }

            this.processData(appId, data)            
        },
        updateAdd(appId, data) {
            if (data.accessRights.add) 
                data.accessRights.view = true
            
            this.processData(appId, data)
        },
        updateEdit(appId, data) {
            if (data.accessRights.edit) 
                data.accessRights.view = true
            
            this.processData(appId, data)
        },
        updateDelete(appId, data) {
            if (data.accessRights.delete) 
                data.accessRights.view = true
            
            this.processData(appId, data)
        },
        updateApprover(appId, data) {
            if (data.accessRights.approver) 
                data.accessRights.view = true
            
            this.processData(appId, data)
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        async getAllApps(run_loading) {
            try {
                this.loading = run_loading
                const response = await appsApi.getAll(this.selectedUserId)
                if (response.status==200) {
                    this.user_detail = response.data.user
                    this.apps_list = JSON.parse(JSON.stringify(response.data.applications))      //deep cloning    
                    this.apps_list_orig = JSON.parse(JSON.stringify(response.data.applications)) //deep cloning
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        getCountPerStatus(appId, status) {
            var data = this.apps_list.filter(x => {
                return x.appId == appId
            })[0]
            var count = data.appPages.filter(x => {
                return x.status==status
            })
            return count.length
        },
        async updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) {
                await this.getAllApps(false)
            }
            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Access Control Details'
        })

        await this.getAllApps(true)
    },
    computed: {
        pageQueryId() {
            return `permissions${this.selectedUserId}`
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.apps,
                    notificationTypeId: notificationTypes.access_permissions
                }
            }
        },
        selectedUserId() {
            return this.$route.params.userId
        },   
        forReviewList() {
            var list = []
            const forReview = commonfn.getStatusCode('For Review')
            if (this.apps_list) {
                this.apps_list.forEach(item => {
                    item.appPages.forEach(page => {
                        if (page.status == forReview) 
                            list.push(page)
                    })
                })
            }
            return list
        },
        hasForReview() {
            return this.forReviewList.length
        },
        hasRevised() {
            if (!this.apps_list) return false

            const rejected = commonfn.getStatusCode('Rejected')
            const forReview = commonfn.getStatusCode('For Review')

            return this.apps_list.some(item =>
                //some() exits once a match is found.
                item.appPages &&
                item.appPages.some(page =>
                    page.status === rejected ||
                    page.status === forReview ||
                    page.status === -1
                )
            )
        },
        hasApproved() {
            if (!this.apps_list) return false
            const approvedStatus = commonfn.getStatusCode('Approved')
            return this.apps_list.some(item =>
                //some() exits once a match is found.
                item.appPages && item.appPages.some(page => page.status === approvedStatus)
            )
        },
        notUpdated() {
            return !this.hasRevised&&!this.hasForReview&&!this.hasApproved
        },
        underRevision() {
            return this.hasRevised
        },
        forReview() {
            return !this.hasRevised&&this.hasForReview
        },
        approved() {
            return !this.hasRevised&&!this.hasForReview&&this.hasApproved
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 20px 0px 50px;
}
.section-layout-mobile {
        padding:0px 10px 0px 10px;
}
.switch-item {
    margin-bottom:-20px;
}
.top-progress {
    margin:1px -3px 0px -3px;
}
</style>